// students/my-model
import { getData } from 'src/services/RestApi';
import { formatDate, currentSeconds } from 'src/utils/date-locale';
import StringUtils from 'src/utils/string-util';
import { dayColor, paymentColor } from 'src/utils/color-rules';
import { formatDisplayNote, formatPhone } from 'src/utils/formatters';
import { getCachedData } from 'src/utils/data-cache';
import { codeStyle } from 'src/utils/code-style';
import { GenderDisplay } from 'src/constants/keys-mapping';

export const getStudentList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/student/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    result.forEach((element) => {
      element.phone = formatPhone(element.phone);
      
      element.gender = GenderDisplay[element.gender];
      element.options = element.trackingName;

    
      element.onlyView = !!element.courseName;
      

      // if(element.key === 'hv'){
      //   element.gender = element.degreeName;
      //   element.options = element.partnerName;
      // }else{
      //   element.gender = gender[element.gender];
      //   if(element.key === 'nv')
      //     element.options = element.email;
      //   else if(element.key === 'gv')
      //     element.options = element.degreeName;
      // }
    });
  }
  return onSuccess(result);
};

export const getStudentById = async (payload) => {
  const studentId = Number(payload?.id) || 0;
  if (studentId === 0) return {};

  const endPoint = 'api/student/detail';
  let { result, error } = await getData(endPoint, { studentId });

  if(error) return {};


  // result.partnerType = partnerMap[result.partnerType];
  result.genderLabel = GenderDisplay[result.gender];
  result.trackingNote = formatDisplayNote(result.trackingNote);
  
  return result;
};

// Get list of student not yet assign to course
export const getStudentNewUnlimitedList = async (payload = {}) => {
  // Get full without spearator
  const { result, error } = await getData('api/student/unlimited-list', {});
  if (error) return payload;

  const jsonList = [];
  result.forEach((element) => {
    jsonList.push({ 
      ...element,
      optionId: element.id, 
      phone: formatPhone(element.phone),
    });
  });

  payload.students = jsonList;
  return payload;
};

export const getStudentNewList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/student/new-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {

    result.forEach((element) => {
      element.phone = formatPhone(element.phone);
      element.gender = GenderDisplay[element.gender];
    });
  }
  return onSuccess(result);
};

export const getStudentTrackingById = async (payload) => {
  const studentId = Number(payload?.id) || 0;
  if (studentId === 0) return {};

  const endPoint = 'api/student/detail-tracking';
  let { result, error } = await getData(endPoint, { studentId });

  if(error) return [];

  result.trackings.forEach((element) => {
    element.remindDate = formatDate(element.remindAt, 'dd/MM/yyyy');
    element.updatedDate = formatDate(element.updatedAt, 'dd/MM/yy HH:mm');
    element.note = formatDisplayNote(element.note);
  });

  return result;
};

